export default "__VITE_ASSET__ace2c60a__"